var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"font-noto-sans"},[_vm._v(" "+_vm._s(_vm.$t('pages.campaignForm.tabs.creatives.popover.status'))+" : "),_c('span',{staticClass:"font-semibold"},[_vm._v(_vm._s(_vm.$t(_vm.getStatus)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }